import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu"
import { Icon, IconPlus, IconX } from "@tabler/icons-react"

import { cn } from "@/lib/utils"

import { Truncate } from "../../Truncate"

export interface FilterPillProps {
  id?: string
  label: string
  onRemove?: () => void
  active?: boolean
  icon?: Icon
  ref?: React.Ref<HTMLSpanElement>
}

export function FilterPill({
  id,
  label,
  active,
  onRemove,
  icon,
  ref,
  ...props
}: FilterPillProps) {
  const Icon = icon

  return (
    <span
      ref={ref}
      id={id}
      className={cn(
        "grid w-fit max-w-75 cursor-pointer grid-cols-[auto_1fr] items-center overflow-hidden rounded border border-border text-body2 text-muted-foreground",
        "focus-outline focus-within:outline-2",
        {
          "border-accent-foreground bg-accent text-foreground": active,
        },
      )}
      data-active={active}
      {...props}
    >
      <DropdownMenuTrigger
        className={cn(
          "peer flex min-w-0 items-center gap-2 py-1 pr-1 pl-3",
          "outline-hidden hover:bg-accent hover:text-muted-foreground focus:bg-accent focus:text-accent-foreground",
          { "pr-3": !onRemove },
        )}
      >
        {Icon ? <Icon size={14} /> : !active ? <IconPlus size={14} /> : null}
        <span className="overflow-hidden">
          <Truncate text={label} />
        </span>
      </DropdownMenuTrigger>
      {onRemove ? (
        <button
          type="button"
          className="group h-full px-1 outline-hidden peer-hover:bg-accent peer-hover:text-muted-foreground focus:bg-accent focus:text-muted-foreground"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          <span className="flex rounded-full p-1 group-hover:bg-accent group-hover:text-muted-foreground">
            <IconX size={14} />
          </span>
        </button>
      ) : null}
    </span>
  )
}
